var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block"},[_c('h3',{staticClass:"title"},[_vm._v("专业解读：")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.zyjd)}})]),_c('div',{staticClass:"block"},[_c('h3',{staticClass:"title"},[_vm._v("就业前景与方向：")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.jyqjyfx)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }